<nav class="cv-studio-rail">
  <div class="cv-studio-rail-section">
    <div class="cv-studio-rail-heading">{{ 'cv_studio.section_builtin' | translate }}</div>
    @for (layout of baseLayouts; track layout.id) {
      <button class="cv-studio-rail-item"
              [class.is-selected]="isBuiltinSelected(layout.id)"
              (click)="pickBuiltin(layout)">
        <span class="cv-studio-rail-item-name">{{ layout.name }}</span>
      </button>
    }
  </div>

  <div class="cv-studio-rail-section">
    <div class="cv-studio-rail-heading">{{ 'cv_studio.section_yours' | translate }}</div>
    @if (templates.length === 0 && !loading) {
      <p class="cv-studio-rail-empty">{{ 'cv_studio.empty_yours_short' | translate }}</p>
    }
    @for (t of templates; track t.id) {
      <button class="cv-studio-rail-item"
              [class.is-selected]="isCustomSelected(t.id)"
              (click)="pickCustom(t)">
        <span class="cv-studio-rail-item-name">{{ t.name }}</span>
        <span class="cv-studio-rail-item-status cv-studio-rail-item-status-{{ t.status }}">{{ 'cv_templates.status.' + t.status | translate }}</span>
      </button>
    }
    <button class="cv-studio-rail-upload" (click)="requestUpload()">+ {{ 'cv_studio.upload_button' | translate }}</button>
  </div>

  <div class="cv-studio-rail-divider"></div>

  <div class="cv-studio-rail-section">
    <button class="cv-studio-rail-item cv-studio-rail-theme"
            [class.is-selected]="isThemeSelected()"
            (click)="pickTheme()">
      <span class="cv-studio-rail-item-name">{{ 'cv_studio.theme_label' | translate }}</span>
    </button>
    <button class="cv-studio-rail-item cv-studio-rail-house"
            [class.is-selected]="isHouseSelected()"
            (click)="pickHouse()">
      <span class="cv-studio-rail-item-name">{{ 'cv_studio.house_label' | translate }}</span>
    </button>
  </div>
</nav>
